var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section-right-content-box"},[_vm._m(0),_c('div',{staticStyle:{"padding":"30px 28px 28px 28px"}},[_c('div',[_c('div',{style:({ width: '100%', height: '400px' }),attrs:{"id":"order-care"}})])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-shadow top-box"},[_c('div',{staticClass:"global-title"},[_vm._v("周期分析")])])
}]

export { render, staticRenderFns }